
export const SET_RUNTIME_VARIABLE = "SET_RUNTIME_VARIABLE";

export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const OPEN_SIDEBAR = "OPEN_SIDEBAR";
export const CLOSE_SIDEBAR = "CLOSE_SIDEBAR";

export const DEPTH_COLOR = ["#FFB051", "#C0C0C0", "#FFF0CC"];